import { createApp } from 'vue'
import App from './App.vue'
import store from './store/index'
import { createHead } from '@vueuse/head'
import router from "./router";
import './assets/main.css'
import './registerServiceWorker'
import VCalendar from 'v-calendar';
import moment from 'moment';
import 'v-calendar/dist/style.css';
import { createMetaManager } from 'vue-meta'
import VueClipboard from 'vue3-clipboard';

//Create head
const head = createHead()

createApp(App)
    .use(router)
    .use(moment)
    .use(store)
    .use(head)
    .use(createMetaManager())
    .use(VCalendar, {})
    .use(VueClipboard, {
        autoSetContainer: true,
        appendToBody: true,
    })
    .mount('#app')
